import { useRef } from 'react';

/**
 * <Footer />
 */
const Footer = () => {
  const cookie = useRef(null);

  const handleClick = () => {
    cookie.current.click();
  };

  return (
    <footer>
      <div className='footer_wrapper'>
        <div className='footer_top'>
          <div className='container footer_top-container'>
            <div className='footer_topper'>
              <div className='footer_contacts'>
                <a className='footer_tel' href='tel:9960'>
                  9960
                </a>
              </div>
              <div className='footer_social'>
                <a
                  href='https://www.instagram.com/zyn.ukraine'
                  target='_blank'
                  className='social_link inst_link'
                />
                <a
                  href='https://www.facebook.com/zynukraine'
                  target='_blank'
                  className='social_link fb_link'
                />
              </div>
            </div>
            <div className='footer_leagal'>
              <div className='footer_link'>
                <a
                  className='link'
                  href='https://d2esxfdt32vo54.cloudfront.net/docs/2025.02_TC_ZYN_Sampling.pdf'
                  target='blank'
                >
                  Умови програми ZYN на тест
                </a>
                <div className='footer_link'>
                  <a
                    className='link '
                    href='https://zyn.com.ua/uk/privacy-policy'
                    target='blank'
                  >
                    Політика конфіденційності
                  </a>
                </div>
                <p className='link' onClick={handleClick}>
                  Налаштування Cookie
                </p>
                <button
                  id='ot-sdk-btn'
                  className='ot-sdk-show-settings'
                  style={{ display: 'none', opacity: '0' }}
                  ref={cookie}
                >
                  Налаштування Cookie
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='footer_bottom'>
          <div className='container'>
            <div className='footer_text'>
              Не виключає усіх ризиків. Містить нікотин, що викликає залежність.
              Лише для використання повнолітніми.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export { Footer };
